import gql from "graphql-tag";
const getConfigQuery = gql(` 
query getConfig($component: String!, $parameter: String!) {
  getConfig(component: $component, parameter: $parameter) {
    component
    parameter
    value
  }
}
`)
export default getConfigQuery;
